import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';

export const FilterBar = ({ children, sticky = true }) => {
  const { theme } = useTheme();
  return (
    <div style={{
      position: sticky ? 'sticky' : 'static',
      top: 0,
      zIndex: 5,
      background: theme.color.surface,
      borderBottom: `1px solid ${theme.color.border}`,
      padding: `${theme.space.md}px ${theme.space.lg}px`,
      display: 'flex',
      gap: theme.space.base,
      alignItems: 'center',
      flexWrap: 'wrap',
      fontFamily: theme.font.family,
    }}>
      {children}
    </div>
  );
};
